<template>
  <div>
    <el-row class="login" style="position: fixed">
      <el-col :span="10" class="login_left">
        <div>
          <p>宿淮盐综合营运管理平台</p>
          <img src="../assets/login_left.png" alt="" />
        </div>
      </el-col>
      <el-col :span="14" class="login_right">
        <transition name="fade">
          <div class="login_pain" v-if="showLogin">
            <div class="login_text">
              <p class="user_login">用户登录</p>
              <p class="forget_pwd" @click="forget_password">忘记密码</p>
            </div>
            <div class="login_input">
              <el-form ref="user" :model="user">
                <el-form-item label="">
                  <el-input
                    autocomplete
                    v-model="user.count"
                    placeholder="输入用户名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    placeholder="请输入密码"
                    v-model="user.password"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitUser('user')"
                    >登录</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <!-- <div class="login_text">
              <p class="user_login"><img src="../assets/wx.png" alt="" /></p>
              <p class="forget_pwd">验证码登录</p>
            </div> -->
          </div>
        </transition>
        <transition name="fade">
          <div class="login_pain" v-if="!showLogin" style="height: 583px">
            <div class="login_text">
              <p class="user_login">
                <i
                  style="cursor: pointer"
                  class="el-icon-back"
                  @click="forget_password"
                ></i
                >&nbsp;&nbsp;&nbsp;重置密码
              </p>
            </div>
            <div class="login_input" style="margin-top: 50px">
              <el-form ref="reset" :model="reset">
                <el-form-item label="">
                  <el-input
                    autocomplete
                    v-model="reset.phoneNumber"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    style="width: 68%"
                    autocomplete
                    v-model="reset.yzm"
                    placeholder="请输入验证码"
                  ></el-input>
                  <el-button @click="sendMessage">发送验证码</el-button>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    placeholder="请输入新密码"
                    v-model="reset.password"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    placeholder="请确认密码"
                    v-model="reset.doublepassword"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item style="margin-top: -10px">
                  <el-button type="primary" @click="submitReset('reset')"
                    >确定</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      showLogin: true,
      user: {
        count: "",
        password: "",
      },
      reset: {
        phoneNumber: "",
        phoneType: "2",
        doublepassword: "",
        password: "",
        yzm: "",
        count: "",
      },
    };
  },
  methods: {
    // sendYzm
    sendMessage() {
      let self = this;
      if (!self.reset.phoneNumber) {
        self.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return false;
      }
      self.$http.get(
        self.api.sendYzm +
          `?phoneNumber=${this.reset.phoneNumber}&type=${this.reset.phoneType}`,
        {},
        function (response) {
          if (response.user) {
          }
        },
        function (response) {
          //失败回调
        }
      );
    },
    submitUser() {
      let self = this;
      if (!self.user.count) {
        self.$message({
          message: "请输入用户名",
          type: "warning",
        });
        return false;
      }
      if (!self.user.password) {
        self.$message({
          message: "请输入密码",
          type: "warning",
        });
        return false;
      }
      let params = new FormData();
      params.append("username", self.user.count);
      params.append("password", self.user.password);
      try {
        self.$http.post(
          self.api.login,
          params,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          },
          (res) => {
            if (res.access_token) {
              self.$store.dispatch("SetToken", res.access_token);
              self.getUserInfo();
              localStorage.setItem("token", res.access_token);
            } else {
              self.$message({
                message: "用户名或密码错误",
                type: "warning",
              });
              return false;
            }
          },
          (error) => {}
        );
      } catch (error) {
        self.$message({
          message: "用户名或密码错误",
          type: "warning",
        });
        return false;
      }
    },
    getUserInfo() {
      let self = this;
      self.$http.get(
        self.api.current,
        {},
        function (response) {
          if (response.user) {
            self.$store.dispatch("SetUserInfo", response.user);
            localStorage.setItem("userInfo", JSON.stringify(response.user));
            self.$router.push({ path: "/authFront/home" });
          }
        },
        function (response) {
          //失败回调
        }
      );
    },
    submitReset() {
      let self = this;
      if (!self.reset.phoneNumber) {
        self.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return false;
      }
      if (!self.reset.password) {
        self.$message({
          message: "请输入密码",
          type: "warning",
        });
      }
      if (!self.reset.yzm) {
        self.$message({
          message: "请输入验证码",
          type: "warning",
        });
      }
      if (self.reset.password != self.reset.doublepassword) {
        self.$message({
          message: "两次密码不一致",
          type: "warning",
        });
        return false;
      }
      self.$http.get(
        self.api.changePassword +
          `?phoneNumber=${self.reset.phoneNumber}&yzm=${self.reset.yzm}&prePassword=${self.reset.password}&password=${self.reset.doublepassword}`,

        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
        function (response) {
          if (response.code == 200 && response.body) {
            self.$message({
              message: "重置密码成功",
              type: "success",
            });
            self.showLogin = !self.showLogin;
          } else {
            self.$message({
              message: response.msg,
              type: "warning",
            });
          }
        },
        function (response) {
          console.log(response);
          //失败回调
        }
      );
      // changePassword
    },
    forget_password() {
      let self = this;
      self.showLogin = !self.showLogin;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-icon-back {
  border: 1px solid #ddd;
  border-radius: 33px;
  padding: 5px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.login {
  width: 100%;
  height: 100%;
  position: fixed;
  background: linear-gradient(230deg, #7dbeff 0%, #0052e7 100%);
}
.login_left {
  position: fixed;
  height: 100%;
  left: 200px;
  text-align: center;
  color: #fff;
  padding: 177px 0 0 0;
  font-size: 42px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 53px;
  letter-spacing: 2px;
}
.login_left img {
  width: 50%;
  margin-top: 10%;
  display: inline-block;
}
.login_right {
  position: fixed;
  right: 0;
}
.login_pain {
  width: 480px;
  height: 520px;
  background: #ffffff;
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.24);
  border-radius: 16px;
  margin: 0 auto;
  margin-top: 19%;
  padding: 56px 48px;
  box-sizing: border-box;
}
.login_text {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 40px;
  clear: both;
  overflow: hidden;
  margin-top: 60 px;
  font-size: 20px;
}
.user_login {
  float: left;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 40px;
}
.forget_pwd {
  float: right;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #2878fc;
  line-height: 40px;
  cursor: pointer;
}
.login_input {
  margin-top: 60px;
}
.login_input .el-input__inner {
  border-top: none;
  border-left: none;
  border-right: none;
  font-size: 18px;
}
.login_input .el-form-item {
  margin-bottom: 40px;
}
.login_input .el-button--primary {
  width: 100%;
  margin-top: 30px;
}
.user_login img {
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue